import { t } from "@/i18n-js/instance";
import type { FormSelectNativeProps } from "@circle-react-shared/uikit/Form/FormSelectNative";
import { Form } from "@circle-react-uikit/Form";
import { SectionCard } from "@circle-react-uikit/SectionCard";
import { DefaultsFormItem } from "./DefaultsFormItem";

const i18nRoot = "landing_page.settings";

interface DefaultsFormProps {
  metaData: {
    postSortOptions: FormSelectNativeProps["options"];
    trendingPostWindowLimit: number;
  };
}

export const DefaultsForm = ({
  metaData = { postSortOptions: [], trendingPostWindowLimit: 0 },
}: DefaultsFormProps) => {
  const { postSortOptions = [], trendingPostWindowLimit } = metaData;

  const validateThresholdValue = (value: number) => {
    if (value > trendingPostWindowLimit) {
      return t([i18nRoot, "trending_posts_window_limit_exceed"], {
        limit: trendingPostWindowLimit,
      });
    }
    if (value < 0) {
      return t([
        i18nRoot,
        "trending_posts_window_in_days_should_not_be_negative",
      ]);
    }
    return true;
  };

  return (
    <SectionCard
      title={t("home_page.edit_form.defaults")}
      variant="fullScreen"
      fullWidth
    >
      <div className="mx-auto flex h-full flex-col">
        {/* <FormItem
                name="tab_heading"
                rules={{
                  required: t(
                    "home_page.edit_form.welcome_banner.title_required",
                  ),
                  maxLength: 255,
                }}
                tooltip={t("landing_page.settings.tab_heading_description")}
              >
                <Form.Input />
              </FormItem> */}
        <DefaultsFormItem
          name="trending_posts_window_in_days"
          tooltip={t(
            "landing_page.settings.trending_posts_window_in_days_description",
          )}
          rules={{
            required: t(
              "landing_page.settings.trending_posts_window_in_days_required",
            ),
            validate: { validateThresholdValue },
          }}
        >
          <Form.Input />
        </DefaultsFormItem>

        <DefaultsFormItem
          name="default_post_sort_logged_in_user"
          tooltip={t(
            "landing_page.settings.default_post_sort_logged_in_user_description",
          )}
        >
          <Form.SelectNative
            name="default_post_sort_logged_in_user"
            options={postSortOptions}
            data-testid="post_sort_logged_in_user"
          />
        </DefaultsFormItem>
        <DefaultsFormItem
          name="default_post_sort_logged_out_user"
          tooltip={t(
            "landing_page.settings.default_post_sort_logged_out_user_description",
          )}
        >
          <Form.SelectNative
            name="default_post_sort_logged_out_user"
            options={postSortOptions}
            data-testid="post_sort_logged_out_user"
          />
        </DefaultsFormItem>
        <DefaultsFormItem
          name="include_non_member_space_posts"
          tooltip={t(
            "landing_page.settings.include_non_member_space_posts_description",
          )}
          variant="default"
          inlineReverse
        >
          <Form.ToggleSwitch
            name="include_non_member_space_posts"
            variant="small"
          />
        </DefaultsFormItem>
      </div>
    </SectionCard>
  );
};
